import React from 'react';
import '../../stylesheets/home/toolsSection.css';

const ToolsSection = () => {
  const tools = [
    {
      title: 'Quiero empleo / mejorar mi perfil',
      description: 'Accede a una ruta digital de empleabilidad que inicia con la identificación de tu Perfil Profesional Digital. Continúa tu proceso con contenidos formativos asincrónicos y herramientas de orientación, que te brindarán recomendaciones personalizadas para fortalecer tu perfil y mejorar tus oportunidades laborales.',
      buttonLabel: 'Iniciar Ruta de Empleabilidad',
      href: '/plans/',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg>
      )
    },
    {
      title: 'Tengo una idea / emprendimiento',
      description: 'Desarrolla tu idea con una ruta formativa asincrónica y asistentes con IA que generan en minutos entregables clave como el mapa de oportunidades, el modelo de negocio en 9 bloques y la ficha de hipótesis MVP. Recibe apoyo continuo del Mentor IA 24/7 durante el proceso.',
      buttonLabel: 'Desarrollar mi Idea de Negocio',
      href: '/plans/',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21a9 9 0 1 0-9-9c0 1.488.504 2.853 1.338 3.937"></path><path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path><path d="M12 15a3 3 0 0 1-3-3"></path></svg>
      )
    },
    {
      title: 'Tengo empresa y quiero escalar / transformar',
      description: 'Impulsa tu crecimiento empresarial con trainings asincrónicos y un wizard de IA para construir tu pitch profesional. Apóyate en el Mentor IA 24/7, que entrega recomendaciones personalizadas para fortalecer tu estrategia y proyección.',
      buttonLabel: <>Impulsar<br />mi Empresa</>,
      href: '/plans/pitch/',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7.5" r="4.5"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line></svg>
      )
    }
  ];

  return (
    <section className="tools-section">
      <div className="container">
        
        <div className="tools-grid">
          {tools.map((tool, index) => (
            <div className="tool-card" key={index}>
              <div className="tool-icon">{tool.icon}</div>
              <h3>{tool.title}</h3>
              <p>{tool.description}</p>
              <a
                href={tool.href || '/plans/'}
                className="cta-button"
                aria-label={typeof tool.buttonLabel === 'string' ? tool.buttonLabel : tool.title}
              >
                {tool.buttonLabel}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;